/* ==========================================================================
   CABINET SCREWS - PDP behaviour.
   GENERATED by _gql/golive/build_pdp_js.py.  Do not hand-edit.

   What this file does NOT do: compute a price.  Every figure it shows comes
   either from Expanse's own rendered price block or from Orbit's
   wholesale-aware product JSON (#cs-pdp-product), which applies the same
   sawholesale discount that block applies.  There is no second pricing path.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.cs-pdp[data-section-id]');
  if (!root) return;
  var D = root.dataset;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || root).querySelectorAll(s));
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var money = function (n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var qty = function (n) { return Number(n).toLocaleString('en-US'); };
  var svg = function (id, w, h, vb) {
    return '<svg width="' + w + '" height="' + h + '"'
      + (vb ? ' viewBox="' + vb + '"' : '')
      + ' aria-hidden="true" focusable="false"><use href="#' + id + '"/></svg>';
  };

  /* the current product's spec, handed over by the section from the tags */
  var P = {
    h: D.handle, sz: D.sz, ln: D.ln, dr: D.dr,
    hd: D.hd, th: D.th, pt: D.pt, fn: D.fn
  };
  var DASH = '—';

  /* ---- VERBATIM from mockups/rc-1/product.html ---- */
  function lenLabel(s) {
    if (/mm$/.test(s)) return s;
    return s.replace(/\s*Inch$/, '').replace(/^(\d+) (\d+\/\d+)$/, '$1-$2') + '"';
  }

  /* CS_TILE_SRC - generated from pdp-tiles/plan/uploaded.json by
     _gql/golive/build_s59_pdp_tiles.py. 27 urls. Regenerate
     rather than hand-editing: the keys must match the values the
     section emits exactly, or a tile silently does not render. */
  var CS_TILE_SRC = {
    drive: {
      'Combo': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-drive-combo.jpg?v=1788269098',
      'Phillips': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-drive-phillips.jpg?v=1788269098',
      'Quadrex': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-drive-quadrex.jpg?v=1788269098',
      'Square': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-drive-square.jpg?v=1788269098',
      'Square-#1': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-drive-square-1.jpg?v=1788269098'
    },
    head: {
      'Fillister': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-fillister.jpg?v=1788269098',
      'Flat': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-flat.jpg?v=1788269098',
      'Flat with Nibs': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-flat-with-nibs.jpg?v=1788269098',
      'Modified Truss': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-modified-truss.jpg?v=1788269098',
      'Pan': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-pan.jpg?v=1788269098',
      'Round Washer': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-round-washer.jpg?v=1788269098',
      'Truss': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-truss.jpg?v=1788269098',
      'Type E': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-type-e.jpg?v=1788269098',
      'Washer': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-head-washer.jpg?v=1788269098'
    },
    thread: {
      'Coarse': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-thread-coarse.jpg?v=1788269098',
      'Deep': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-thread-deep.jpg?v=1788269098',
      'Euro': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-thread-euro.jpg?v=1788269099',
      'Fine': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-thread-fine.jpg?v=1788269098',
      'Twinfast': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-thread-twinfast.jpg?v=1788269098'
    },
    point: {
      'Dual Cutter': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-dual-cutter.jpg?v=1788269098',
      'Euro': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-euro.jpg?v=1788269098',
      'Long Type 17': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-long-type-17.jpg?v=1788269098',
      'Machine Screw': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-machine-screw.jpg?v=1788269098',
      'Sharp': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-sharp.jpg?v=1788269098',
      'Twinfast': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-twinfast.jpg?v=1788269098',
      'Type 17': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-type-17.jpg?v=1788269098',
      'Type A': 'https://cdn.shopify.com/s/files/1/0588/1312/0717/files/tile-point-type-a.jpg?v=1788269098'
    }
  };
  /* the rail caption is the AXIS, not the value: "Thread" is 48px in the
     78px label box at the 14px floor, where "Twinfast" would be 74px and
     "Modified Truss" would overflow. The value is on the tile itself and in
     the accessible name. */
  var TILE_AXES = [
    { k: 'drive',  p: 'dr', label: 'Drive' },
    { k: 'head',   p: 'hd', label: 'Head' },
    { k: 'thread', p: 'th', label: 'Thread' },
    { k: 'point',  p: 'pt', label: 'Point' }
  ];
  /* CS_TILE_SRC_BLOCK - the four secondary views.

     These used to be four inline-SVG squares drawn here (Shipping / Support /
     Indiana / 40 years). They are now designed 1500x1500 tiles carrying THIS
     product's own spec values, rendered off Shopify Files. The drawing on each
     one is the same sprite symbol the spec chips use, so the tile and the chip
     can never disagree.

     A value with no tile is skipped rather than rendered blank - `Type A`
     point exists on 37 products and had no metafield, which is exactly the
     case that would otherwise show an empty square. */
  function tileViews() {
    var out = [];
    TILE_AXES.forEach(function (ax) {
      var val = P[ax.p];
      if (!val || val === DASH) return;
      var src = (CS_TILE_SRC[ax.k] || {})[val];
      if (!src) return;
      out.push({
        k: 'tileimg',
        img: src,
        label: ax.label,
        alt: 'Cabinet Screws \u2014 ' + val + ' ' + ax.k,
        a11y: ax.label + ': ' + val
      });
    });
    return out;
  }



  /* ------------------------------------------------------------- gallery
     View 0 is the photograph the SECTION already rendered - it is reused
     rather than re-fetched, so the server-rendered <img> stays the one the
     browser downloaded.  Views 1..4 are the brand tiles above.

     This is also what retires the old grey axis renders: the gallery is the
     featured image plus generated tiles and never reads the product's other
     media, so phillips_drive.png / pan_head.png / *_finish.jpg stop being
     shown with NO product-data change.  61 of the 275 products have no real
     photograph at all, and deleting media would have emptied their gallery. */
  var stage = $('#stage');
  var rail = $('#thumbs');
  var seed = stage ? stage.querySelector('img') : null;
  var PIMG = seed ? seed.getAttribute('src') : '';
  var PALT = seed ? seed.getAttribute('alt') : '';
  /* APPENDS width when there is none. The old body was
       u.replace(/([?&])width=\d+/, '$1width=180') which is a no-op on a
       Shopify Files url - they look like `...tile-head-pan.jpg?v=1788266511`
       and carry no width - so a 100px thumb was pulling the full 1500px
       image. Measured: 137 KB each instead of 21 KB, four times over. */
  var sized = function (u, w) {
    if (!u) return u;
    if (/([?&])width=\d+/.test(u)) {
      return u.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  };
  var thumbSrc = function (u) { return sized(u, 180); };

  var VIEWS = [];
  if (PIMG) {
    VIEWS.push({ k: 'photo', img: PIMG, alt: PALT, label: 'Photo',
                 a11y: 'Product photo' });
  }
  VIEWS = VIEWS.concat(tileViews());
  var view = 0;

  function renderGallery() {
    if (!stage || !rail) return;
    rail.hidden = VIEWS.length < 2;
    /* --tn is the real view count; the rail was hard-coded to six columns
       once and every thumb sat in an empty sixth slot. */
    rail.style.setProperty('--tn', VIEWS.length);
    rail.innerHTML = VIEWS.map(function (v, i) {
      return '<button class="thumb" type="button" data-v="' + i + '"'
        + ' aria-pressed="' + (i === view) + '"'
        + ' aria-label="' + esc(v.a11y || v.label)
        + (v.k === 'tile' ? ' tile' : ' view') + '">'
        + '<img loading="lazy" src="' + esc(thumbSrc(v.img)) + '" alt="">'
        + '<span class="tl">' + esc(v.label) + '</span></button>';
    }).join('');
    $$('#thumbs [data-v]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        view = +btn.dataset.v;
        renderGallery();
      });
    });
    var v = VIEWS[view] || VIEWS[0];
    if (!v) return;
    /* the photograph keeps the src the server already rendered, so the
       browser reuses its download; a tile is sized for the 518px stage. */
    stage.innerHTML = v.k === 'photo'
      ? '<img src="' + esc(v.img) + '" alt="' + esc(v.alt || '') + '">'
      : '<img src="' + esc(sized(v.img, 1100)) + '" alt="'
        + esc(v.alt || '') + '">';
  }

  /* --------------------------------------------------- Orbit product JSON */
  var PJ = null;
  try {
    var el = document.getElementById('cs-pdp-product');
    if (el) PJ = JSON.parse(el.textContent);
  } catch (e) { PJ = null; }

  /* qty(option1) -> variant, out of Orbit's JSON.  Prices are in CENTS and
     already carry the customer's wholesale discount. */
  var BYQ = {};
  if (PJ && PJ.variants) {
    PJ.variants.forEach(function (v) {
      var n = parseInt(v.option1, 10);
      if (!isNaN(n)) BYQ[n] = v;
    });
  }
  var QS = Object.keys(BYQ).map(Number).sort(function (a, b) { return a - b; });

  /* ------------------------------------------------- the box selector
     Expanse's radios, enriched.  Nothing here changes which variant is
     selected or what it costs - it adds the piece count, the per-box price
     and the saving to a control the theme still owns. */
  function paintBoxes() {
    var wrap = $('#p-boxwrap');
    if (!wrap) return;
    var legend = wrap.querySelector('.kit-fieldset__legend-text');
    if (legend) legend.textContent = 'Choose your box';
    var base = QS.length ? (BYQ[QS[0]].price / 100) / QS[0] : 0;
    $$('.kit-radio', wrap).forEach(function (label) {
      var input = label.querySelector('.kit-radio__input');
      var btn = label.querySelector('.kit-button');
      if (!input || !btn || label.dataset.csDone === '1') return;
      var n = parseInt(input.value, 10);
      var v = BYQ[n];
      if (isNaN(n) || !v) return;
      label.dataset.csDone = '1';
      label.style.order = String(QS.indexOf(n));
      var dollars = v.price / 100;
      btn.innerHTML =
        '<span class="cs-radio" aria-hidden="true"></span>'
        + '<span class="cs-q">' + qty(n) + '<small>screws</small></span>'
        + '<span class="cs-pr">' + money(dollars) + '</span>';
      /* Only a REAL saving gets a tag.  "Same per screw" and the per-screw
         sub-line are gone (Brandon 2026-08-27: "we are not selling in
         eaches") - the unit of sale is the box, so the tile states the box. */
      var save = base ? (1 - (dollars / n) / base) * 100 : 0;
      if (QS.indexOf(n) > 0 && save >= 5) {
        var tag = document.createElement('span');
        tag.className = 'cs-tag';
        tag.setAttribute('aria-hidden', 'true');
        tag.textContent = 'Save ' + save.toFixed(0) + '%';
        label.appendChild(tag);
      }
    });
  }

  /* ------------------------------------------------------------- siblings
     Length and finish are separate PRODUCTS in this catalogue, so each
     option is a navigation.  The index is a theme asset because Liquid
     cannot enumerate 275 products from inside a product section. */
  function sameExcept(rows, key) {
    var axes = ['sz', 'ln', 'dr', 'hd', 'th', 'pt', 'fn'];
    return rows.filter(function (o) {
      for (var i = 0; i < axes.length; i++) {
        var a = axes[i];
        if (a === key) continue;
        if (o[a] !== P[a]) return false;
      }
      return true;
    });
  }

  function renderLengths(rows) {
    var wrap = $('#p-lenwrap');
    var sel = $('#p-len');
    if (!wrap || !sel) return;
    var sibs = sameExcept(rows, 'ln').sort(function (a, b) {
      /* the store's own Length sort key ("AK", "BI", "ZJ"), which orders the
         inch sizes correctly and puts the three metric lengths last.  Sorting
         a fraction like "1 1/8 Inch" by parsing it would be a second, worse
         copy of an ordering the catalogue already states. */
      return a.lk < b.lk ? -1 : (a.lk > b.lk ? 1 : 0);
    });
    /* one option is not a choice - the same rule as the finish picker */
    if (sibs.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    sel.innerHTML = sibs.map(function (o) {
      return '<option value="' + esc(o.h) + '"'
        + (o.h === P.h ? ' selected' : '') + '>'
        + esc(lenLabel(o.ln)) + '</option>';
    }).join('');
    sel.addEventListener('change', function (e) {
      var h = e.target.value;
      if (h && h !== P.h) location.href = '/products/' + encodeURIComponent(h);
    });
  }

  function renderFinishPick(rows, base) {
    var wrap = $('#p-finwrap');
    var box = $('#p-fins');
    if (!wrap || !box) return;
    /* A DETERMINISTIC order.  The mockup's came out of its own baked table
       and the theme's out of the catalogue index, and the two disagreed -
       the geometry diff flagged `.fin` as 102px on one side and 201px on the
       other, which turned out not to be a size difference at all but Zinc
       and Black Phosphate in opposite order.  Neither order was designed, so
       this picks one that can be predicted: alphabetical, with an unspecified
       finish last. */
    var sibs = sameExcept(rows, 'fn').sort(function (a, b) {
      if (a.fn === DASH) return 1;
      if (b.fn === DASH) return -1;
      return a.fn < b.fn ? -1 : (a.fn > b.fn ? 1 : 0);
    });
    /* One option is not a choice.  74 of the 275 carry no finish value at
       all, and plenty of specs exist in a single finish - in both cases a
       picker with one entry is dead UI, so the whole fieldset goes and the
       value stays in the Specifications table where it is still stated. */
    if (sibs.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    /* 2026-10-01, CMS parity: round 34px swatches, the way centurymadeshop.com
       shows a material, with the current finish spelled out in the legend
       (cs-product.liquid .fin-cur) and each swatch's name in its title and
       aria-label.  EVERY finish is a colour chip (Brandon, 2026-10-01: a row
       of plating photos with one plain chip among them read as inconsistent).
       The colours are the spec-dot palette in cs-product.liquid (chip_fn /
       dot_fn), so the swatch, the spec pill and the spec table can never
       disagree - change a colour in all three places.  A sheen and a shade
       make a flat colour read as plated metal. */
    var CHIP = {
      'Zinc': '#C9CCD2', 'Black Phosphate': '#1A1A1A', 'Black Oxide': '#232323',
      'Black': '#111111', 'Dry Lube / Plain': '#9AA0A6', 'Nickel': '#D8DBE0',
      'Stat Bronze': '#7A5230', 'Ultraguard': '#8C9AA6'
    };
    var SHEEN = 'radial-gradient(circle at 34% 28%,rgba(255,255,255,.62) 0,rgba(255,255,255,0) 52%),'
      + 'radial-gradient(circle at 72% 78%,rgba(0,0,0,.22) 0,rgba(0,0,0,0) 62%)';
    box.innerHTML = sibs.map(function (o) {
      var me = o.h === P.h;
      var label = o.fn === DASH ? 'Not specified' : o.fn;
      var art = 'background-color:' + (CHIP[o.fn] || '#E6E2DA') + ';background-image:' + SHEEN;
      return '<a class="finsw" href="/products/' + esc(o.h) + '"'
        + (me ? ' aria-current="page"' : '')
        + ' title="' + esc(label) + '" aria-label="' + esc(label) + '">'
        + '<span class="fsw" aria-hidden="true" style="' + esc(art) + '"></span></a>';
    }).join('');
  }

  function loadCatalog() {
    if (!D.catalog || !window.fetch) return;
    fetch(D.catalog, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (doc) {
        if (!doc || !doc.p || !doc.k) return;
        var rows = doc.p.map(function (a) {
          var o = {};
          doc.k.forEach(function (k, i) { o[k] = a[i]; });
          return o;
        });
        renderLengths(rows);
        renderFinishPick(rows, doc.base || '');
      })
      .catch(function () { /* both pickers stay hidden - see above */ });
  }

  /* ------------------------------------------------------------------ sync
     Everything that follows the SELECTED BOX.  It reads the selection off
     Expanse's own radio, and it never decides what is selected. */
  var unitEl = $('#p-unit');
  var qlbl = $('#q-lbl');
  var pal = $('#cs-pal');
  var bbPrice = $('#bb-price');
  var bbSub = $('#bb-sub');
  var bbAdd = $('#bb-add');
  var submit = D.submit ? document.getElementById(D.submit) : null;

  function selectedQty() {
    var input = $('.boxsel .kit-radio__input:checked');
    if (input) {
      var n = parseInt(input.value, 10);
      if (!isNaN(n)) return n;
    }
    return QS.length ? QS[0] : 0;
  }

  function nBoxes() {
    var q = $('.stepper input');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  /* "· palletised" belongs INSIDE Expanse's own inventory sentence, the way
     the mockup wrote it ("In stock, ready to ship · palletised").  As a
     sibling of <product-inventory> it inherited .ft's 10px flex gap and read
     as a third, unrelated item.  Expanse re-renders the inventory block on
     every variant change, so this is idempotent: it finds or creates its own
     span each time rather than appending. */
  function palletised(on) {
    var host = root.querySelector('.fulfil .icon-and-text > span:last-of-type');
    if (!host) return;
    var tag = host.querySelector('.cs-pal-in');
    if (!on) { if (tag) tag.remove(); return; }
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'cs-pal-in';
      host.appendChild(tag);
    }
    tag.textContent = ' · palletised';
  }

  function sync() {
    var n = selectedQty();
    var v = BYQ[n];
    var boxes = nBoxes();
    if (unitEl) unitEl.textContent = n ? 'per box of ' + qty(n) : '';
    if (qlbl) qlbl.textContent = boxes === 1 ? 'box' : 'boxes';
    if (pal) pal.hidden = true;      /* the Liquid placeholder is never shown */
    palletised(n >= 1000);
    if (bbSub) {
      bbSub.textContent = (boxes > 1 ? boxes + ' boxes · ' : '')
        + qty(n) + ' screws per box';
    }
    if (bbPrice) {
      bbPrice.textContent = v ? money((v.price / 100) * boxes) : '';
    }
    if (bbAdd) {
      var off = submit ? submit.disabled : false;
      bbAdd.disabled = off;
      bbAdd.textContent = off ? 'Unavailable' : 'Add to cart';
    }
  }

  /* -------------------------------------------------------------- buy bar
     Reveal once the real Add-to-cart has scrolled past.

     Two bugs, both measured on the render rather than reasoned about.
     1. Keying on `!isIntersecting` is TRUE on BOTH sides of the anchor - at
        375 that meant the bar fully out at scroll 0, covering 68px of the
        first screen with a buy button for a product nobody had seen.
     2. Fixing that with the observer's own geometry was still wrong: a JUMP
        scroll (a fling, a deep link, a restored scroll position) moves the
        anchor from below the viewport to above it WITHOUT EVER
        INTERSECTING, so the callback never fires at all.
     So the state comes from geometry, read behind a requestAnimationFrame
     gate.  A handler that cannot miss beats one that is free and wrong. */
  function buyBar() {
    var bar = $('#buybar');
    var anchor = $('.qtyrow');
    if (!bar || !anchor) return;
    var TOP_GAP = 72;
    document.body.dataset.bb = bar.dataset.on || '0';
    var set = function (on) {
      var val = on ? '1' : '0';
      if (bar.dataset.on === val) return;
      bar.dataset.on = val;
      document.body.dataset.bb = val;
    };
    var queued = false;
    var update = function () {
      queued = false;
      set(anchor.getBoundingClientRect().bottom <= TOP_GAP);
    };
    var onScroll = function () {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    update();
    /* the bar's height is what the fixed corner widgets have to clear; read
       it rather than hardcode it, so a copy change cannot silently leave the
       widgets sitting on top of the bar again. */
    var lift = function () {
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h > 2) {
        document.documentElement.style.setProperty('--bb-lift', (h - 4) + 'px');
      }
    };
    lift();
    if ('ResizeObserver' in window) new ResizeObserver(lift).observe(bar);
    if (bbAdd && submit) {
      bbAdd.addEventListener('click', function () { submit.click(); });
    }
  }

  /* ------------------------------------------------------------------ wire
     The picker re-renders the price block asynchronously, so the price is
     not correct at the moment `change` fires.  A MutationObserver on the
     block is what actually tracks it; the change listeners are what make
     the quantity label and the box tag respond immediately. */
  renderGallery();
  paintBoxes();
  sync();
  buyBar();
  loadCatalog();

  root.addEventListener('change', function () { paintBoxes(); sync(); });
  root.addEventListener('input', sync);

  var price = $('block-price');
  if (price && 'MutationObserver' in window) {
    new MutationObserver(function () { paintBoxes(); sync(); })
      .observe(price, { childList: true, subtree: true, characterData: true,
                        attributes: true });
  }
  if (submit && 'MutationObserver' in window) {
    new MutationObserver(sync)
      .observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }
  /* kit's own selection event, when it is available - belt and braces */
  document.addEventListener('shopify:product:select', function () {
    paintBoxes(); sync();
  });
})();
